<template>
<div class="file-detail-wrapper">
    <div class="nav-main-con">
        <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
        <span>首页</span>
        <span class="sp-nav-line">></span>
        <span v-if="xType == 'jdx'" class="sp-nav-link" @click="toXHome">酒店运营管理</span>
        <span v-if="xType == 'cyx'" class="sp-nav-link" @click="toXHome">餐饮管理运行</span>
        <span class="sp-nav-line">></span>
        <span @click="toXHome" class="sp-nav-link">试点工作文件</span>
        <span class="sp-nav-line">></span>
        <span>文件详情</span>
    </div>
    <div class="file-detail-main">
        <PreparingCourseware :sourceId="fileId" :savesession="false"></PreparingCourseware>
    </div>
</div>
</template>

<script>
import PreparingCourseware from "components/filePerview.vue";
export default {
    data() {
        return {}
    },
    props: {
        xType: {
            type: String,
            default: ''
        },
        fileId: {
            type: String,
            default: ''
        }
    },
    components: {
        PreparingCourseware
    },
    created() {

    },
    methods: {
        toXHome() {
            this.$router.push({
                name: 'xView',
                params: {
                    xType: this.xType
                }
            });
        },
    }
}
</script>

<style lang="scss">
.file-detail-wrapper {
    .nav-main-con {
        margin: 0 auto;
        width: 1200px;
        height: 40px;
        line-height: 40px;
        color: #333333;
        font-size: 14px;

        .sp-nav-line {
            margin: 0 6px;
        }

        .sp-nav-link {
            cursor: pointer;
        }

        .sp-nav-link:hover {
            color: #05243D;
        }
    }

    .file-detail-main {
        margin: 0 auto 40px;
        padding: 20px 30px 50px 30px;
        width: 1200px;
        height: 800px;
        border: 1px solid #d3dbe5;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1.6;

        .file-name-con {
            margin: 20px 0;
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            color: #05243D;
        }

        .imgblowup {
            display: none;
        }
    }
}

@media only screen and (max-width: 768px) {
    .file-detail-wrapper {
        .nav-main-con {
            padding: 0 20px;
            width: 100%;
            font-size: 13px;
        }

        .file-detail-main {
            padding: 10px 15px;
            width: 100%;
            background: #fff;
            font-size: 13px;

            .file-name-con {
                font-size: 16px;
            }
        }
    }
}
</style>
